import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-border-light">404</h1>
        <h2 className="text-2xl font-bold text-text-primary mb-2">{t("pages.notFound.title")}</h2>
        <p className="text-text-secondary mb-8">{t("pages.notFound.subtitle")}</p>
        <Link
          to="/"
          className="bg-primary-600 hover:bg-primary-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
        >
          {t("pages.notFound.goHome")}
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
